import { InspectionFormItem } from '../../types/inspectionForm';

/** 인수검사성적서 기본 양식명 */
export const ACCEPTANCE_FORM_SAMPLE_TITLE = '인수검사성적서';

export const ACCEPTANCE_FORM_SAMPLE_MEMO =
  '검사항목은 양식에서 비워 두고, 인수검사 실행 때 사용자가 채웁니다.';

/** 검사항목은 실행 시 행 추가로 입력 (양식에는 비워 둠) */
export const ACCEPTANCE_FORM_SAMPLE_ITEMS: InspectionFormItem[] = [];

export const HEADER_META_FIELDS = [
  { label: '품명', hint: '재고 품목 선택 시 자동' },
  { label: '규격', hint: '실행 시 입력' },
  { label: 'Lot No.', hint: '실행 시 입력' },
  { label: '재질', hint: '실행 시 입력' },
  { label: '입고 수량', hint: '실행 시 입력' },
  { label: '검사자', hint: '실행 시 입력' },
  { label: '업체명', hint: '실행 시 입력' },
  { label: '입고 일자', hint: '실행 시 입력' },
  { label: '검사 일자', hint: '실행 시 입력' },
  { label: '분류', hint: '예: 반도체류 · 광원' },
] as const;
